module.exports = __webpack_public_path__ + "img/logo.ef738ce6.png";